export enum ResultEnum {
	NA = 'NA',
	MOINS_1M = 'MOINS_1M',
	DE_1M_A_10M = 'DE_1M_A_10M',
	DE_10M_A_20M = 'DE_10M_A_20M',
	PLUS_20M = 'PLUS_20M'
}

export enum RevenueEnum {
	NA = 'NA',
	MOINS_2M = 'MOINS_2M',
	DE_2M_A_10M = 'DE_2M_A_10M',
	DE_10M_A_20M = 'DE_10M_A_20M',
	DE_20M_A_30M = 'DE_20M_A_30M',
	DE_30M_A_40M = 'DE_30M_A_40M',
	PLUS_40M = 'PLUS_40M'
}

export enum EquityEnum {
	NA = 'NA',
	MOINS_100K = 'MOINS_100K',
	DE_100K_A_1M = 'DE_100K_A_1M',
	DE_1M_A_2M = 'DE_1M_A_2M',
	PLUS_2M = 'PLUS_2M'
}
